<template>
  <div>
    <v-row v-if="coursLignefiltre.length > 0">
      <v-col cols="12" sm="12" md="6" lg="4" v-for="coursLigne in coursLignefiltre" v-bind:key="coursLigne.id">
        <v-card outlined class="pa-3 cardCours cardCoursPrincipal">
          <div>
            <v-row class="columnBoiteCours py-1">
              <v-col cols="9" class="petiteInformationBoiteCours">
                <label style="font-weight: bold; color: black">
                  {{ coursLigne.codeMatiere }}
                </label>
                |
                <label v-if="coursLigne.bloc != null">
                  {{ coursLigne.bloc.identifiant }}
                </label>
                <label v-else>
                  -
                </label>
              </v-col>
              <v-col cols="3" class="petiteInformationBoiteCours text-right">
                <label style="font-weight: bold; color: black" v-if="affichagePrix(coursLigne) != null">
                  {{ affichagePrix(coursLigne) }}$
                </label>
              </v-col>
            </v-row>

            <v-row class="columnBoiteCours py-0">
              <v-col cols="12" class="py-0">
                <label class="d-block titreCoursLigne py-0">
                  {{ coursLigne.titre }}
                </label>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="py-0">
                <label class="titreBoiteCours texteImportant">
                  {{ obtenirTypeCoursLabel(coursLigne.typeCours) }}
                </label>
              </v-col>
              <v-col cols="6" class="py-0 text-right">
                <label v-if="appStore.modele.optionRegionale.inscriptionExamenOuverte" class="titreBoiteCours">
                  {{ $t("enum.ModaliteExamen." + coursLigne.modaliteExamen) }}
                </label>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pb-0">
                <label class="titreBoiteCours d-block" style="
                    font-weight: bold;
                    color: black;
                    width: 100%;">
                  {{ obtenirLabelConditionAdminission }}</label>

                <label class="titreBoiteCours" style="white-space: pre-wrap;">{{ coursLigne.consigne }}</label>
              </v-col>
            </v-row>
          </div>

          <div class="containerBtnEtInfos mt-6">
            <div style="width: 55%">
              <div v-if="coursLigne.description" class="titreBoiteCours texteImportant">
                <label>{{ coursLigne.description }}</label>
              </div>
            </div>
            <div style="width: 45%;" class="text-right">
              <label v-if="coursLigne.estListeAttente" class="titreBoiteCours lblAucunePlace mb-3">
                {{ $t("boutique.boiteListeCours.Complet") }}
              </label>

              <v-btn v-if="!estDejaAjoutePanier(coursLigne)" v-on:click.stop="ajouterAuPanier(coursLigne)"
                :disabled="estDisabled(coursLigne)" class="boutonAjouterBoiteCours grosseurBoutonsBoutique"
                :loading="btnChargement">
                <p class="texteBoutonsBoutique ma-0">{{ texteBoutonAjouter(coursLigne) }}</p>
              </v-btn>

              <v-btn v-else v-on:click.stop="supprimerPanier(coursLigne)" class="boutonRetirerBoiteCours"
                :loading="btnChargement">
                <label>{{ $t("boutique.boiteListeCours.Retirer") }}</label>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12">
        <v-card outlined class="pa-3 cardCours" style="border: 2px solid #095797">
          <div>
            <v-card-title class="aucunCoursDispo" v-html="messageErreurAucunCours()">
            </v-card-title>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import csqcOutils from '@/outils/CSQCOutils';
import csqcOutilsCoursEte from '@/outils/CSQCOutilsCoursEte';
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
import usePanierStore from '@/store/panierStore';
import {
  TypeCours, NiveauScolaire, PorteeCours, EtatCours,
} from '@/outils/Enum';

const racineLocalStorage = 'csqc_coursEte_';
const selectionInscriptionLocalStorage = 'selectionInscription';
const panierLocalStorage = 'Panier';
const cssIdLocalStorage = 'CSSId';

export default {
  name: 'CoursLigne',
  props: {
    filtreObjet: Object,
    listeCoursLigne: Array,
  },
  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();
    const panierStore = usePanierStore();

    return { appStore, inscriptionStore, panierStore };
  },
  data() {
    return {
      btnChargement: false,
    };
  },
  async created() {
    let CSSId = localStorage.getItem(racineLocalStorage + cssIdLocalStorage);
    CSSId = CSSId == null ? -1 : CSSId;
    await this.inscriptionStore.definirOrganismeGratuit(CSSId);
  },
  computed: {
    coursLignefiltre() {
      let coursFiltree = [];

      coursFiltree = this.listeCoursLigne;

      if (
        this.filtreObjet.selectNiveauScolaire.valeur !==
        NiveauScolaire.TousLesNiveaux
      ) {
        coursFiltree = coursFiltree.filter(
          (x) => x.niveau === this.filtreObjet.selectNiveauScolaire.valeur,
        );
      }

      if (
        this.filtreObjet.rechercheBarre !== '' &&
        this.filtreObjet.rechercheBarre !== null &&
        this.filtreObjet.rechercheBarre !== undefined
      ) {
        coursFiltree = coursFiltree.filter(
          (x) => x.titre
            .toLowerCase()
            .includes(this.filtreObjet.rechercheBarre.toLowerCase()) ||
            x.categorie.identifiant
              .toLowerCase()
              .includes(this.filtreObjet.rechercheBarre.toLowerCase()) ||
            x.codeMatiere
              .toLowerCase()
              .includes(this.filtreObjet.rechercheBarre.toLowerCase()),
        );
      }

      if (this.filtreObjet.selectOffreCours != null) {
        if (
          this.filtreObjet.selectOffreCours.cssId === -1
        ) {
          coursFiltree = coursFiltree.filter(
            (x) => x.portee === PorteeCours.Regional,
          );
        } else {
          coursFiltree = coursFiltree.filter(
            (x) => x.portee === PorteeCours.Regional ||
              (x.cssId != null &&
                x.portee === PorteeCours.Local &&
                x.cssId === this.filtreObjet.selectOffreCours.cssId),
          );
        }
      }

      coursFiltree.sort((a, b) => a.titre.localeCompare(b.titre));

      return coursFiltree;
    },
    obtenirLabelConditionAdminission() {
      if (this.appStore.modele.optionRegionale.inscriptionOuverte) {
        return this.$t('boutique.boiteListeCours.ConditionAdmission');
      }
      if (this.appStore.modele.optionRegionale.inscriptionExamenOuverte) {
        return this.$t('boutique.boiteListeCours.Detail');
      }
      return '';
    },

    estExterne() {
      return csqcOutilsCoursEte.EstExterne();
    },
    estCssMembre() {
      return csqcOutilsCoursEte.EstCSSMembre();
    },
    estCssExterne() {
      return csqcOutilsCoursEte.EstCSSExterne();
    },
    estPrive() {
      return csqcOutilsCoursEte.EstPrive();
    },
    estScolariseMaison() {
      return csqcOutilsCoursEte.EstScolariseMaison();
    },
  },
  methods: {
    messageErreurAucunCours() {
      if (this.filtreObjet.selectOffreCours != null) {
        const optionCss = this.inscriptionStore.obtenirOptionCss(this.filtreObjet.selectOffreCours.cssId);
        const lienCoursLocaux = csqcOutilsCoursEte.ObtenirURLPlateforme(optionCss);
        // Si les option css sont null ou qu'il n'y a pas de cours que se donne en présentiel et pour les examens locaux
        // ou la période d'examen n'est pas encore ouverte
        if (optionCss == null || lienCoursLocaux === '' || !this.appStore.modele.optionRegionale.inscriptionExamenOuverte) {
          return this.$t('boutique.filtres.AucunCoursDisponible');
        }
        return `${this.$t('boutique.filtres.CoursPresentiel')} <a target="_blank" href="${lienCoursLocaux}">${lienCoursLocaux}</a>.`;
      }
      return this.$t('boutique.filtres.AucunCoursDisponible');
    },
    texteBoutonAjouter(coursLigne) {
      if (coursLigne.etat === EtatCours.Complet) {
        return this.$tc('boutique.boiteListeCours.boutonComplet');
      }

      if (coursLigne.estListeAttente) {
        return this.$tc('boutique.boiteListeCours.Attente');
      }

      return this.$tc('boutique.boiteListeCours.Ajouter');
    },
    obtenirTypeCoursLabel(valeur) {
      if (valeur === TypeCours.Virtuel) {
        return this.$t('boutique.boiteListeCours.TypeCoursVirtuel');
      }

      if (valeur === TypeCours.Presentiel) {
        return this.$t('boutique.boiteListeCours.TypeCoursPresentiel');
      }
      return '—';
    },
    ajouterAuPanier(cours) {
      this.btnChargement = true;
      const coursPanierAvant = csqcOutils.Cloner(this.panierStore.listeCoursPanier);

      let estIncompatible = false;
      coursPanierAvant.forEach((coursPanier) => {
        if (!estIncompatible) {
          if (
            coursPanier.bloc.blocsIncompatible != null &&
            cours.bloc.blocsIncompatible != null
          ) {
            if (
              coursPanier.bloc.blocsIncompatible.filter(
                (c) => c.id === cours.bloc.id,
              ) != null &&
              coursPanier.bloc.blocsIncompatible.filter(
                (c) => c.id === cours.bloc.id,
              ).length !== 0
            ) {
              estIncompatible = true;
            }
          } else {
            estIncompatible = false;
          }
        }
      });

      if (!estIncompatible) {
        const cssNom = this.inscriptionStore.listeCssMinimise.filter((item) => item.cssId === cours.cssId)[0]?.nom;
        const messagePresentiel = {
          title: this.$t('boutique.dialog.ConfirmationCoursPresentiel'),
          body: `${this.$t('boutique.dialog.SouhaitezVous')}<b>${cours.titre} (${cours.codeMatiere})</b> 
            ${this.$t('boutique.dialog.OffertPresentiel')}${cssNom != null ? `${this.$t('boutique.dialog.ParLe')} <b>${cssNom}</b>` : ''}?`,
        };
        const messageListeAttente = {
          title: this.$t('boutique.dialog.ConfirmationCoursEnAttente'),
          // eslint-disable-next-line max-len
          body: `${this.$t('boutique.dialog.SouhaitezVousListeAttente')}<b>${cours.titre} (${cours.codeMatiere})</b>${cssNom != null ? `${this.$t('boutique.dialog.Offert')}<b>${cssNom}</b>` : ''}?<br><br><i>${this.$t('avertissement.placeNonGarantie')}</i>`,
        };

        if (cours.typeCours === TypeCours.Presentiel) {
          this.$dialog.confirm(messagePresentiel, { loader: true }).then((dialog) => {
            if (cours.estListeAttente) {
              dialog.close();
              this.$dialog.confirm(messageListeAttente, { loader: true }).then((dialogue) => {
                this.ajouterCoursPanier(cours);
                dialogue.close();
              });
            } else {
              this.ajouterCoursPanier(cours);
              dialog.close();
            }
          });
        } else if (cours.estListeAttente) {
          this.$dialog.confirm(messageListeAttente, { loader: true }).then((dialog) => {
            this.ajouterCoursPanier(cours);
            dialog.close();
          });
        } else {
          this.ajouterCoursPanier(cours);
        }
      } else {
        // popup
        const message = {
          title: this.$t('boutique.dialog.TitreAvertissement'),
          body: this.$t('boutique.dialog.ErreurBlocIncompatible'),
        };

        this.$dialog.alert(message);
      }

      this.btnChargement = false;
    },
    async ajouterCoursPanier(cours) {
      const coursPanierAvant = csqcOutils.Cloner(this.panierStore.listeCoursPanier);

      if (coursPanierAvant != null && coursPanierAvant.length !== 0) {
        if (coursPanierAvant.filter((x) => x.id === cours.id).length === 0) {
          coursPanierAvant.push(cours);
          const jsonCoursPanier = JSON.stringify(coursPanierAvant);

          localStorage.setItem(
            racineLocalStorage + panierLocalStorage,
            jsonCoursPanier,
          );
          await this.panierStore.definirListeCoursPanier(coursPanierAvant);
        }
      } else {
        coursPanierAvant.push(cours);

        await this.panierStore.definirListeCoursPanier(coursPanierAvant);
        const jsonCoursPanier = JSON.stringify(coursPanierAvant);

        localStorage.setItem(
          racineLocalStorage + panierLocalStorage,
          jsonCoursPanier,
        );
      }
    },
    supprimerPanier(cours) {
      this.$dialog
        .confirm(this.$t('boutique.dialog.Suppression'), {
          loader: true,
        })
        .then(async (dialog) => {
          this.btnChargement = true;
          const coursPanierAvant = csqcOutils.Cloner(
            this.panierStore.listeCoursPanier,
          );

          const coursPanierRetrait = coursPanierAvant.filter(
            (x) => x.id !== cours.id,
          );

          await this.panierStore.definirListeCoursPanier(coursPanierRetrait);

          const jsonCoursPanier = JSON.stringify(coursPanierRetrait);
          localStorage.setItem(
            racineLocalStorage + panierLocalStorage,
            jsonCoursPanier,
          );
          this.btnChargement = false;
          dialog.close();
        });
    },

    estDejaAjoutePanier(coursLigne) {
      const coursPanierAvant = csqcOutils.Cloner(this.panierStore.listeCoursPanier);

      if (coursPanierAvant != null) {
        return (
          coursPanierAvant.filter((x) => x.id === coursLigne.id).length !== 0
        );
      }
      return false;
    },
    estDisabled(coursLigne) {
      // Si le cours est dans l'état complet (2), le bouton est désactivé
      if (coursLigne.etat === EtatCours.Complet) {
        return true;
      }

      if (this.appStore.modele.optionRegionale.inscriptionTermine && this.appStore.modele.optionRegionale.inscriptionExamenTermine) {
        return true;
      } if (
        !csqcOutilsCoursEte.EstExterne() &&
        !this.appStore.modele.optionRegionale.inscriptionOuverte &&
        !this.appStore.modele.optionRegionale.inscriptionExamenOuverte
      ) {
        return true;
      } if (
        csqcOutilsCoursEte.EstExterne() &&
        !this.appStore.modele.optionRegionale.inscriptionExterneOuverte &&
        !this.appStore.modele.optionRegionale.inscriptionExamenOuverte
      ) {
        return true;
      }

      return false;
    },
    affichagePrix(cours) {
      const organismesGratuit = this.inscriptionStore.listeOrganismeGratuit;

      // Vérifiez que la réponse est bien un tableau
      if (!Array.isArray(organismesGratuit)) {
        return null;
      }

      const organisme = organismesGratuit.find((org) => org.organismeId === localStorage.getItem(racineLocalStorage + selectionInscriptionLocalStorage));

      // Si l'organisme offre les cours gratuits
      if (organisme != null) {
        if (this.estScolariseMaison && !organisme.scolariseMaison) {
          return cours.prixScolarise;
        }

        return 0;
      }
      if (this.estScolariseMaison) {
        return cours.prixScolarise;
      } if (this.estCssMembre) {
        return cours.prixCSSMembre;
      } if (this.estCssExterne) {
        return cours.prixExterne;
      } if (this.estPrive) {
        return cours.prixPrive;
      }

      // Si rien ne fonctionne, retourner null. Important de ne pas mettre 0, parce que le cours n'est pas forcément gratuit
      return null;
    },
  },
};
</script>

<style scoped>
.titreBoiteCours {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}

.cardCours {
  min-height: 100px;
}

.cardCoursPrincipal {
  border: 2px solid #095797;
  min-height: 325px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.boutonPoubelleBoiteCours {
  color: black !important;
  min-height: 48px !important;
}

.aucunCoursDispo {
  text-align: center !important;
  display: inherit;
}

.boutonAjouterBoiteCours {
  background-color: #095797 !important;
  border-color: #095797 !important;
  color: white !important;
  min-height: 48px !important;
}

.boutonRetirerBoiteCours {
  background-color: white !important;
  border: solid 1px #095797 !important;
  color: #095797 !important;
  min-height: 48px !important;
}

.texteImportant {
  color: #095797;
}

.petiteInformationBoiteCours {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}

.columnBoiteCours {
  padding: 0;
}

.titrePage {
  font-family: Passion One;
}

.lblAucunePlace {
  font-weight: bold;
  color: black;
  width: 100%;
  display: block;
  text-align: right;
  line-height: 1.25rem;
}

.containerBtnEtInfos {
  display: flex;
  align-items: flex-end;
}

@media screen and (min-width: 475px) {
  .cardCours {
    min-width: 390px !important;
  }
}
</style>
